// FieldDescriptionField.jsx

import React from 'react';

// Components
import ModalField from 'components/modal/field/ModalField';
import ModalHint from 'components/modal/hint/ModalHint';
import ModalLabel from 'components/modal/label/ModalLabel';
import TextInput from 'components/textinput/TextInput';

/**
 * FieldDescriptionField
 *
 * Renders the description input for a field in the field modal.
 *
 * @param {string} value - The current description value.
 * @param {function} onChange - Handler for when the description changes.
 *
 * @returns {ReactNode} The rendered component.
 */
const FieldDescriptionField = ({
    value,
    onChange,
}) => {

  // ----- RENDER ----- //

  return (

    <ModalField>

        <ModalLabel label="Description" />
        <ModalHint hint="The optional, longer description for the field." />

        <TextInput
          expandable
          maxLength={240}
          multiline
          placeholder="Optional help text..."
          showCount
          value={value}
          onChange={(event) => onChange(event.target.value)}
        />

    </ModalField>
);
};

// Dev Tools
FieldDescriptionField.displayName = 'FieldDescriptionField';

export default FieldDescriptionField;
